
// const BASE_URL = "https://r1propturtle.com/r1/api/public/api";

// export default BASE_URL;

// const BASE_URL = "https://r1propturtle.in/api/public/api";
// const BASE_URL = "http://127.0.0.1:8000/api";

// export default BASE_URL;
// const BASE_URL = "https://r1propturtle.in/api";
// const BASE_URL = "https://r1propturtle.in/api/public";

// const BASE_URL = "https://r1propturtle.in/api/public/api";

// export default BASE_URL;

// const BASE_URL = "https://r1propturtle.in/api";

// export default BASE_URL;

// const BASE_URL = "http://127.0.0.1:8000/api";

// export default BASE_URL;   

const BASE_URL = "https://r1propturtle.in/api/api";

export default BASE_URL;